
export function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'As safe as a commercial aircraft',
      description: 'On the path to certification with aviation authorities, our aircraft is designed to meet the highest safety standards in the industry.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Zero in-flight emissions',
      description: 'Powered by battery technology, it emits zero CO2, nitric oxide (NOx), and other harmful pollutants during flight – making flying more sustainable.'
    },
    {
      icon: 'ri-volume-down-line',
      title: 'Notably quiet',
      description: 'In contrast to helicopters, our quiet pioneer seamlessly blends into the cityscape – inaudible at a 120-meter distance within such an environment.'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header Section with Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              WE ARE THE FIRST
            </h3>
            <h3 className="text-3xl md:text-4xl font-light text-gray-900">
              To bring electric air aircraft to cities worldwide
            </h3>
            <p className="mt-6 text-lg text-gray-600 max-w-3xl">
              Our DJT air aircraft will be among the first internationally certified eVTOL aircraft.
            </p>
          </div>
          
          <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://readdy.ai/api/search-image?query=Advanced%20electric%20vertical%20takeoff%20and%20landing%20eVTOL%20drone%20aircraft%20with%20multiple%20visible%20rotors%20and%20fans%2C%20white%20and%20cyan%20color%20scheme%2C%20sleek%20futuristic%20design%20showing%20propeller%20blades%20clearly%2C%20professional%20product%20photography%20on%20clean%20white%20background%2C%20detailed%20view%20of%20fan%20propulsion%20system%2C%20cutting-edge%20autonomous%20air%20mobility%20vehicle%2C%20modern%20aerospace%20engineering%2C%20high-tech%20transportation%20innovation%20with%20emphasis%20on%20rotor%20technology%2C%20studio%20lighting%20highlighting%20mechanical%20details&width=800&height=600&seq=drone-aircraft-fans-feature&orientation=landscape"
              alt="DJT Drone Aircraft with Fans"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-8 rounded-lg">
              <div className="w-16 h-16 bg-teal-500/10 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-teal-500`}></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
